import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ha-mypage l-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "ha__ttl c-ttl" }, "退会", -1)
const _hoisted_3 = { class: "ha__sec ha-mypage__sec" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "p-mypage__txt" }, "よろしければ退会理由をご記入ください。", -1)
const _hoisted_5 = { class: "p-mypage__field-container has-mt" }
const _hoisted_6 = { class: "p-fields" }
const _hoisted_7 = { class: "c-field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "detail"
}, "退会理由", -1)
const _hoisted_9 = { class: "c-field__body" }
const _hoisted_10 = { class: "c-field__textarea" }
const _hoisted_11 = { class: "c-field has-submit has-mt" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "戻る", -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_router_view),
    _createElementVNode("section", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.asyncDeterringWrap(_ctx.withdrawal, this)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("fieldset", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("textarea", {
                    id: "detail",
                    name: "detail",
                    class: "textarea",
                    cols: "",
                    rows: "5",
                    spellcheck: "false",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.leaveNote) = $event)),
                    placeholder: "こちらに詳細を入力してください。"
                  }, null, 512), [
                    [_vModelText, _ctx.leaveNote]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                type: "submit",
                class: _normalizeClass(["ha-btn is-submit", { 'is-disabled':_ctx.isDeterringRef }])
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.withdrawalBtnWord), 1)
              ], 2),
              _createElementVNode("button", {
                type: "button",
                class: "ha-btn ha-btn--outline",
                disabled: _ctx.isDeterringRef,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.backLinkageSite && _ctx.backLinkageSite(...args)))
              }, _hoisted_14, 8, _hoisted_12)
            ])
          ])
        ])
      ], 32)
    ])
  ]))
}